/* Lucky You landing page — email gate, code reveal (scratch / instant / plain), copy button.
   Behavior is driven by data attributes on the .bb-lucky section root:
     data-reveal = "scratch" | "instant" | "plain"
     data-gate   = "on" | "off"
     data-code   = the discount code
     data-klaviyo-form = Klaviyo embed form ID (fallback native form used if the embed never renders)
*/
(function () {
  var root = document.querySelector('.bb-lucky');
  if (!root) return;

  var CODE = root.dataset.code || '';
  var gateStage = root.querySelector('.ly-gate-stage');
  var codeStage = root.querySelector('.ly-code-stage');
  var scratchWrap = root.querySelector('.ly-scratch-wrap');
  var canvas = root.querySelector('.ly-scratch-canvas');
  var codeSub = root.querySelector('.ly-code-sub');
  var scratchBuilt = false;

  function showCode() {
    if (gateStage) gateStage.style.display = 'none';
    codeStage.classList.add('show');
    var mode = root.dataset.reveal;
    if (mode === 'scratch') {
      codeSub.textContent = 'Scratch the card below to reveal it.';
      canvas.style.display = '';
      if (!scratchBuilt) buildScratch();
    } else {
      codeSub.textContent = mode === 'instant'
        ? 'Tap the button to copy it, then use it at checkout.'
        : 'Use it at checkout for workshops or the store.';
      canvas.style.display = 'none';
      canvas.classList.add('gone');
    }
  }

  // ---------- email gate ----------
  // When the Klaviyo embed renders, hide the native fallback form and reveal
  // the code on the embed's submit event.
  var klaviyoDiv = root.querySelector('.ly-klaviyo-gate');
  var fallbackForm = root.querySelector('.ly-gate-form');
  if (klaviyoDiv && fallbackForm) {
    var poll = setInterval(function () {
      if (klaviyoDiv.childElementCount > 0) { fallbackForm.style.display = 'none'; clearInterval(poll); }
    }, 400);
    setTimeout(function () { clearInterval(poll); }, 15000);
    window.addEventListener('klaviyo-form', function (e) {
      var d = e.detail || {};
      if (d.type === 'submit' && (!d.formId || d.formId === root.dataset.klaviyoForm)) { showCode(); }
    });
  }
  if (fallbackForm) {
    fallbackForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = fallbackForm.querySelector('input[type="email"]');
      var v = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { input.classList.add('err'); input.focus(); return; }
      input.classList.remove('err');
      // Fallback path only (Klaviyo embed didn't render): subscribe via the
      // Klaviyo client API, fire-and-forget so a network hiccup never blocks
      // the reveal. The company id comes from the klaviyo.js tag the Klaviyo
      // app injects on every page.
      var listId = root.dataset.klaviyoList;
      var kjs = document.querySelector('script[src*="klaviyo.js"]');
      var companyId = kjs && (kjs.src.match(/company_id=([A-Za-z0-9]+)/) || [])[1];
      if (listId && companyId && window.fetch) {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: v } } },
                custom_source: 'Lucky You landing page'
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        }).catch(function () {});
      }
      showCode();
    });
  }

  // ---------- scratch-off ----------
  function buildScratch() {
    scratchBuilt = true;
    var rect = scratchWrap.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    canvas.width = rect.width * dpr; canvas.height = rect.height * dpr;
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    var w = rect.width, h = rect.height;
    var grad = ctx.createLinearGradient(0, 0, w, h);
    grad.addColorStop(0, '#97C459'); grad.addColorStop(0.55, '#639922'); grad.addColorStop(1, '#2D5A1B');
    ctx.fillStyle = grad; ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = 'rgba(234,243,222,0.14)';
    for (var i = 0; i < 130; i++) { ctx.beginPath(); ctx.arc(Math.random() * w, Math.random() * h, Math.random() * 1.6 + 0.4, 0, 7); ctx.fill(); }
    ctx.fillStyle = '#EAF3DE';
    ctx.font = '700 13px "Source Sans Pro", sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText('SCRATCH TO REVEAL', w / 2, h / 2 - 12);
    ctx.font = '600 12px "Source Sans Pro", sans-serif';
    ctx.fillText('🌱 lucky you 🌱', w / 2, h / 2 + 12);

    var scratching = false, cleared = false;
    function scratchAt(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath(); ctx.arc(x, y, 26, 0, 7); ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
    }
    function pos(e) { var r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    function checkCleared() {
      if (cleared) return;
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var blank = 0, total = 0;
      for (var i = 3; i < data.length; i += 4 * 24) { total++; if (data[i] === 0) blank++; }
      if (blank / total > 0.42) { cleared = true; canvas.classList.add('gone'); dropLeaves(); }
    }
    canvas.addEventListener('pointerdown', function (e) { scratching = true; canvas.setPointerCapture(e.pointerId); var p = pos(e); scratchAt(p.x, p.y); });
    canvas.addEventListener('pointermove', function (e) { if (!scratching) return; var p = pos(e); scratchAt(p.x, p.y); });
    canvas.addEventListener('pointerup', function () { scratching = false; checkCleared(); });
    canvas.addEventListener('pointercancel', function () { scratching = false; });
  }

  function dropLeaves() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    for (var i = 0; i < 12; i++) {
      var l = document.createElement('span');
      l.className = 'ly-leafbit';
      l.style.left = (Math.random() * 100) + '%';
      l.style.top = '-10px';
      l.style.animationDelay = (Math.random() * 0.35) + 's';
      l.style.background = ['#97C459', '#639922', '#FAC775'][i % 3];
      scratchWrap.appendChild(l);
      setTimeout(function (el) { return function () { el.remove(); }; }(l), 2000);
    }
  }

  // ---------- copy ----------
  var copyBtn = root.querySelector('.ly-copy-btn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var label = copyBtn.querySelector('.ly-copy-label');
      function done() {
        copyBtn.classList.add('copied');
        label.textContent = 'Copied!';
        setTimeout(function () { copyBtn.classList.remove('copied'); label.textContent = 'Copy code'; }, 2200);
      }
      function fallback() {
        var ta = document.createElement('textarea'); ta.value = CODE; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        ta.remove();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(CODE).then(done, fallback); } else { fallback(); }
    });
  }

  // ---------- init ----------
  if (root.dataset.gate === 'off') { showCode(); }
})();
